<template>
    <div class="page">
        <compare-sect-v2 background="background-img"></compare-sect-v2>
        <how-worsks background="background-grey" ></how-worsks>
        <content-part></content-part>
        <city-part background="background-img"></city-part>
        <title-part></title-part>
        <title-part background="background-grey"></title-part>
        <content-nd-compare></content-nd-compare>
        <faq-new></faq-new>
        <other-service></other-service>
        <div class="to-app-btn">
            <button class="back-btn"><img src="/img/icon/arrow-down-white.svg" alt=""> Back to application</button>
        </div>
    </div>
</template>

<script>
    import HowWorsks from './page-part/HowWorks'

    import ContentPart from './page-part/ContentPart'
    import CityPart from './page-part/cityPart'
    import TitlePart from './page-part/titlePart'
    import ContentNdCompare from './page-part/contentNdCompare'
    import FaqNew from './page-part/FaqNew'
    import OtherService from './page-part/otherService'
    import CompareSectV2 from './page-part/CompareSectV2'

    export default {
        name: "landing",
        data: function(){
            return {
            }
        },
        components: {
            OtherService,
            ContentNdCompare,
            TitlePart,
            CityPart,
            ContentPart,
            HowWorsks,
            FaqNew,
            CompareSectV2



        },
        methods: {


        },
        computed: {

        },
    }

</script>
